<template>
    <div>
        <v-select
            v-if="!buttons && !autocomplete"
            :items="staff"
            :value="value"
            :prepend-inner-icon="hideIcon ? null : 'people'"
            :loading="loading"
            :hideDetails="hideDetails"
            :clearable="clearable"
            :rules="rules"
            :disabled="disabled"
            outlined
            dense
            return-object
            no-data-text="No staff available"
            item-text="name"
            item-value="id"
            label="Select Staff"
            @input="$emit('input', $event)"
            @click:clear="$emit('clear')"
        />
        <v-autocomplete
            v-if="autocomplete && !buttons && !loading"
            :value="value"
            :items="staff"
            :search-input.sync="search"
            :hide-details="hideDetails"
            :prepend-inner-icon="hideIcon ? null : 'people'"
            :loading="loading"
            :disabled="disabled"
            :error-messages="error"
            :rules="rules"
            return-object
            outlined
            autofocus
            dense
            item-value="id"
            item-text="name"
            no-data-text="No users found"
            label="Select Staff"
            class="soli-blue-text"
            @input="$emit('input', $event)"
            @keydown.enter.prevent
        >
            <template v-slot:item="data">
                <v-list-item-avatar>
                    <img
                        :src="
                            data.item.profile_photo_path
                                ? `/api/image-service/40x40/${data.item.profile_photo_path}`
                                : data.item.profile_photo_url
                        "
                    />
                </v-list-item-avatar>
                <v-list-item-content
                    :class="{ 'disabled-item': data.item.disabled }"
                >
                    <v-list-item-title
                        v-html="data.item.name"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                        v-if="can('Work') && $page.props.staffView"
                        v-html="data.item.email"
                    ></v-list-item-subtitle>
                </v-list-item-content>
                <div
                    v-if="
                        data.item.locations &&
                        !data.item.locations
                            ?.map((e) => e.id)
                            .includes(
                                $page.props.auth.user.selected_location.id
                            )
                    "
                    class="flex flex-col align-end my-auto"
                >
                    <v-icon color="dark">wrong_location</v-icon>
                </div>
            </template>
        </v-autocomplete>
    </div>
</template>

<script>
export default {
    props: {
        value: {},
        error: {},
        buttons: {
            type: Boolean,
            default: false,
        },
        hideDetails: {},
        hideIcon: {},
        clearable: {},
        rules: {},
        rateOnly: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        autocomplete: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            staff: [],
            loading: false,
            search: "",
        };
    },
    methods: {
        getApiStaff() {
            this.loading = true;
            axios
                .get("/api/users/staff", {
                    params: { rateOnly: Number(this.rateOnly) },
                })
                .then((resp) => {
                    this.staff = resp.data;
                    this.loading = false;
                })
                .catch((error) => {
                    this.$emit("error", error);
                });
        },
    },
    mounted() {
        this.getApiStaff();
    },
};
</script>

<style></style>
